import { RefObject, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LOCATION_CHANGE = 'LOCATION_CHANGE';
const LOCATION_REQUEST = 'LOCATION_REQUEST';

/** Mirrors chat.js: push on navigation, and answer the iframe's `LOCATION_REQUEST` on boot. */
export const useWidgetLocationSync = (
  iframeRef: RefObject<HTMLIFrameElement | null>,
  widgetOrigin: string,
): void => {
  const location = useLocation();

  const postLocation = useCallback(() => {
    iframeRef.current?.contentWindow?.postMessage(
      { type: LOCATION_CHANGE, fullPathUrl: window.location.href },
      widgetOrigin,
    );
  }, [iframeRef, widgetOrigin]);

  useEffect(() => {
    postLocation();
  }, [postLocation, location.pathname, location.search, location.hash]);

  useEffect(() => {
    const handleLocationRequest = (event: MessageEvent) => {
      if (event.data?.type !== LOCATION_REQUEST) return;
      if (event.source !== iframeRef.current?.contentWindow) return;
      postLocation();
    };

    window.addEventListener('message', handleLocationRequest);
    return () => window.removeEventListener('message', handleLocationRequest);
  }, [iframeRef, postLocation]);
};
